const welcomeText = `JAKK is a simple full stack, single page application geared towards 
aiding students sitting for various O - Level Examinations with a progressive and 
accessible means of practicising. Students are required to sign up for a free account,
 take tests in over 17 subjects as their records over time are being displayed on a chart 
 for a visual representation of their progress.`
 export default welcomeText;